(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('userRoleService', userRoleService);

    /* @ngInject */
    function userRoleService($http, $q, exception, logger, coreService, $odata, $odataresource, config) {
        var service = {
            getModalOptions: getModalOptions,
            getDefaultUserRole: getDefaultUserRole,
            getUserRoleFields: getUserRoleFields,
            getUserRoles: getUserRoles,
            saveUserRole: saveUserRole,
            deleteUserRole: deleteUserRole,
            deleteUserRoleByUserAndRole: deleteUserRoleByUserAndRole,
            getUserRolesByUser: getUserRolesByUser,
            getODataResource: getODataResource,
            getTableConfig: getTableConfig
        };

        activate();

        return service;

        function activate() {
        }

        function getODataResource() {
            return $odataresource(config.apiUrl + 'odata/UserRoles',
                    {},
                    {},
                    {
                        odatakey: 'UserRoleId',
                        isodatav4: true
                    });
        }

        function getDefaultUserRole(UserId) {
              return {
                ApplicationId: 0,
                UserId: UserId
            };
        }

        function getTableConfig() {
            return {
                columns: [
                    {
                        id: 'RoleName',
                        displayName: 'Role Name',
                        ODataKey: 'Role/RoleName',
                        type: 'subItem'
                    },
                    {
                        id: 'ApplicationName',
                        displayName: 'Application Name',
                        ODataKey: 'Role/Application/ApplicationName',
                        type: 'subItem'
                    }
                ],
                actions: []
            };
        }

        function getUserRoleFields(roles) {
            var Fields = [
                 {
                     key: 'RoleId',
                     type: 'ui-select-single-group',
                     ngModelAttrs: {
                         customAttrVal: {
                             attribute: 'disabled'
                         }
                     },
                     templateOptions: {
                        optionsAttr: 'bs-options',
                        label: 'Roles',
                        ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                        options: roles,
                        valueProp: 'RoleId',
                        labelProp: 'RoleName',
                        groupBy: function(item) {
                            return item.Application;
                        },
                        placeholder: 'Select User Role'
                     }
                 }
            ];
            return Fields;
        }

        function preProcessUserRoleOData(tableState) {
            var query = service.getODataResource().odata();            

            if (!!tableState) {
                coreService.processODataFilters(query, tableState.search.predicateObject, getTableConfig().columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
            }
            tableState.sort = tableState.sort.predicate ? tableState.sort : {
                predicate: 'Role/RoleName', reverse: false
            };
            coreService.processODataSort(query, tableState.sort);

            return query;
        }

        function postProcessUserRoleOData(query) {
            return query
                .expand('User')
                .expand('Role')
                .expand('Role','Application')
                .withInlineCount()
                .query()
                .$promise;
        }

        function getUserRoles(tableState) {
            return postProcessUserRoleOData(preProcessUserRoleOData(tableState));
        }

        function getUserRolesByUser(userId, tableState) {
            return postProcessUserRoleOData(
                preProcessUserRoleOData(tableState)
                    .filter('UserId', new $odata.Value(parseInt(userId).toString(), 'Int32')));
        }

        function saveUserRole(userRole) {
            return coreService.httpAccountsPost('UserRole', userRole);
        }

        function deleteUserRole(userRole) {
            var url = 'UserRole/';
            url = url + encodeURIComponent(userRole.UserRoleId);
            return coreService.httpAccountsPost(url, userRole);
        }

        function deleteUserRoleByUserAndRole(userID, roleID) {
            var url = 'UserRole/User/';
            url = url + encodeURIComponent(userID);
            url = url + '/Role/';
            url = url + encodeURIComponent(roleID);
            return coreService.httpAccountsPost(url);
        }

        function getModalOptions() {
            return {
                animation: true,
                templateUrl: 'app/user/role/dashboard/modal/user.role.modal.html',
                controllerAs: 'vm'
            };
        }
    }
})();
